import React from 'react';

import Link from 'atomic/link/link';
import certSvg from 'assets/images/layout/opineo-cert.inline.svg';
import cert2Svg from 'assets/images/layout/opineo-cert2.inline.svg';
import platinumCertSvg from 'assets/images/layout/platinum-cert.inline.svg';

const FooterCerts: React.FC = () => (
    <div className="footer__certs">
        <h4 className="footer__certs-header">
            Nasze certyfikaty
        </h4>
        <div className="footer__certs-list">
            <Link className="footer__certs-link" href="https://odznaki.opineo.pl/" wrapper={true}>
                <img src={platinumCertSvg} alt="Odznaka złota Opineo" className="footer__certs-img"
                    loading="lazy"
                />
            </Link>
            <Link className="footer__certs-link" href="https://odznaki.opineo.pl/" wrapper={true}>
                <img src={cert2Svg} alt="Certyfikat Opineo" className="footer__certs-img"
                    loading="lazy"
                />
            </Link>
            <Link className="footer__certs-link" href="https://dolacz.opineo.pl" wrapper={true}>
                <img src={certSvg} alt="Certyfikat Opineo" className="footer__certs-img"
                    loading="lazy"
                />
            </Link>
        </div>
    </div>
);

export default FooterCerts;
